import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faTrophyStar } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Constants } from '../../../../../utils/constants';

const MathSkillReportOption = ({threshold,setThreshold,score,correct,inCorrect}) => {

  const handleThreshold =(e)=>{
    const value = parseInt(e.target.value);
    if (isNaN(value) || /^\d{0,2}$/.test(value)) {
      setThreshold(isNaN(value) ? '':value);
    }
    
  };
  return (
    <div className='mt-4'>
      <h6>Report Options</h6>
      <div className='d-flex justify-content-between mt-4'>
        <div className="d-flex align-items-center custom_input">
          <label className='mr-2'>
                Scoring Threshold
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip className="custom-tooltip">
                This is the score that will determine the cutoff for the blue/red bars.
                </Tooltip>
              }>
              <FontAwesomeIcon className="ms-1" color="#88CBF1" icon={faQuestionCircle} />
            </OverlayTrigger>
          </label>
          <input
            className="form-control w-20 text-center"
            onChange={(e) =>handleThreshold(e)}
            value={threshold}
          />
        </div>
        <div className="d-flex">
          <div className="indicator-blue"></div>
          <p className="mx-1">{`>= ${isNaN(threshold) ? 0 : threshold}%`} </p>
          <div className="indicator-red mx-1"></div>
          <p className="mx-1">{`< ${isNaN(threshold) ? 0 : threshold}%`}</p>
        </div>
      </div>
      <div className='row progress_bar_details mt-5'>
        <div className='col-lg-3 total-progress-bar'>
          <CircularProgressbar
            className='mt-3'
            value={score}
            text={score +'%'}
            strokeWidth={18}
            styles={buildStyles(Constants.getProgressBarStyles(score,threshold))}
          />
        </div>
        <div className='col-lg-9 my-auto'>
          <div className='row'>
            <div className='col-lg-4 d-flex'>
              <div className='flex-column w-100'>
                <div className='mb-4'><h5>Grand Total</h5></div>
                <div className="progress-bar-card mt-3">
                  <CircularProgressbar
                    className='h-70'
                    value={correct}
                    text={correct +'%'}
                    strokeWidth={18}
                    styles={buildStyles(Constants.getProgressBarStyles(correct,threshold))}
                  />
                  <div className="flex-column m-2">
                    <p>{correct}</p>
                    <span>Correct</span>
                  </div>
                </div>
                <div className="progress-bar-card">
                  <CircularProgressbar
                    className='h-70'
                    value={inCorrect}
                    text={inCorrect +'%'}
                    strokeWidth={18}
                    styles={buildStyles(Constants.getProgressBarStyles(inCorrect,threshold))}
                  />
                  <div className="flex-column m-2">
                    <p>{inCorrect}</p>
                    <span>Incorrect</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 mt-5">
              <div className="total-score-card w-100">
                <FontAwesomeIcon icon={faTrophyStar} />
                <p>
                  <strong>{score}</strong>
                </p>
                <h6>Total Score</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
MathSkillReportOption.propTypes={
  threshold :PropTypes.number,
  setThreshold :PropTypes.func,
  score :PropTypes.number,
  correct :PropTypes.number,
  inCorrect :PropTypes.number,
};
export default MathSkillReportOption;